import React from 'react';
import block from 'bem-cn-lite';
import Marker from '../../Components/Marker/';
import { I18n } from 'react-i18next'

class FrameImageArea extends React.Component {
    getNodePosition(node) {
        const rect = node.getBoundingClientRect();

        return {
            x: rect.left,
            y: rect.top
        };
    }

    getCursorPosition(event, node) {
        const {x, y} = this.getNodePosition(node);

        return {
            x: event.nativeEvent.clientX - x,
            y: event.nativeEvent.clientY - y,
        };
    }

    handleClick = (event) => {
        const {isActive, onClick} = this.props;

        if (!isActive) {
            return false;
        }

        const markerPosition = this.getCursorPosition(event, this.imageWrap);
        const imageWrapSize = {
            width: this.imageWrap.offsetWidth,
            height: this.imageWrap.offsetHeight
        };

        onClick(markerPosition, imageWrapSize);
    }

    addStylesToCursor({x, y}) {
        this.cursor.style.top = `${y}px`;
        this.cursor.style.left = `${x}px`;
        this.cursor.visibility = 'visible';
    }

    handleMouseMove = (event) => {
        const {isActive, isCollapsed} = this.props;
        let cursorPosition;

        if (!isActive || isCollapsed) {
            return false;
        }

        cursorPosition = this.getCursorPosition(event, this.frameImageArea);

        this.addStylesToCursor(cursorPosition);
    }

    render() {
        const b = block('FrameImageArea');

        const {isActive, isCollapsed, image, markerPosition, imageWrapSize} = this.props;

        return (
            <I18n>
            {
                (t) => (
                    <div
                        className={b({collapsed: isCollapsed, isActive: isActive})}
                        ref={(ref) => this.frameImageArea = ref}
                        onMouseMove={this.handleMouseMove}
                        onClick={this.handleClick}>
        
                        {
                            !isCollapsed && isActive &&
                            <div className={b('tooltip')}>
                                {t('videoProofing:tooltips.beforeHover')}
                            </div>
                        }
        
                        {
                            !isCollapsed && isActive &&
                            <div
                                ref={(ref) => this.cursor = ref}
                                className={b('cursor-tooltip')}>
                                {t('videoProofing:tooltips.onMouseHover')}
                            </div>
                        }
        
                        {!isCollapsed && isActive && <div className='blink'/>}
        
                        <div
                            ref={(ref) => this.imageWrap = ref}
                            className={b('image-wrap')}>
                                <img alt={ image } src={image} key={image}/>
                            {markerPosition &&
                            <Marker position={markerPosition} containerSize={imageWrapSize}/>}
                        </div>
                    </div>
                )
            }
            </I18n>
            
        )
    }
}

export default FrameImageArea;